__turbopack_context__.v({
  "container": "ProductMetaForm-module-scss-module__xJr_sW__container",
  "floatingHeader": "ProductMetaForm-module-scss-module__xJr_sW__floatingHeader",
  "hasSelectedVariant": "ProductMetaForm-module-scss-module__xJr_sW__hasSelectedVariant",
  "imageContainer": "ProductMetaForm-module-scss-module__xJr_sW__imageContainer",
  "metaContainer": "ProductMetaForm-module-scss-module__xJr_sW__metaContainer",
  "priceAddition": "ProductMetaForm-module-scss-module__xJr_sW__priceAddition",
  "pricingContainer": "ProductMetaForm-module-scss-module__xJr_sW__pricingContainer",
  "productPlaceholderImage": "ProductMetaForm-module-scss-module__xJr_sW__productPlaceholderImage",
  "show": "ProductMetaForm-module-scss-module__xJr_sW__show",
});
